export class Debouncer {
  private prevTime: number;
  private timer: any;

  constructor(private interval: number) {
    this.prevTime = 0;
    this.timer = null;
  }

  execute(callback: () => void, delay: number) {
    if (Date.now() - this.prevTime < this.interval) {
      clearTimeout(this.timer);
    } else {
      this.prevTime = Date.now();
    }
    this.timer = setTimeout(() => {
      callback();
    }, delay);
  }
}
